import { Link } from "react-router-dom";

function RadarMark({ light }) {
  const ring = light ? "#c6c2ea" : "#4038b5";
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true" className="shrink-0">
      <circle cx="12" cy="12" r="10.5" stroke={ring} strokeWidth="1.5" />
      <circle cx="12" cy="12" r="6" stroke={ring} strokeWidth="1.2" opacity="0.55" />
      <path d="M12 12 L19.4 4.6" stroke={ring} strokeWidth="1.6" strokeLinecap="round" />
      <circle cx="12" cy="12" r="1.8" fill={ring} />
      <circle cx="16.2" cy="9.2" r="1.3" fill={light ? "#f8f7f3" : "#202344"} />
    </svg>
  );
}

export default function Logo({ tone = "dark", size = "md", to = "/", testid = "site-logo" }) {
  const light = tone === "light";
  const text = size === "lg" ? "text-[26px]" : "text-[21px]";
  return (
    <Link
      to={to}
      aria-label="SaaSRadarHub home"
      data-testid={testid}
      className="inline-flex items-center gap-2 leading-none select-none whitespace-nowrap"
    >
      <RadarMark light={light} />
      <span className="whitespace-nowrap">
        <span className={`font-playfair italic font-medium ${text} ${light ? "text-white" : "text-neutral-900"}`}>
          SaaS
        </span>
        <span className={`font-inter font-bold tracking-tight ${text} ${light ? "text-indigo-200" : "text-indigo-800"}`}>
          RadarHub
        </span>
      </span>
    </Link>
  );
}
